import { useContext } from 'react'

import FieldDisabledContext from '../context/FieldDisabledContext'

const useFieldDisabledContext = () => useContext(FieldDisabledContext)

export default useFieldDisabledContext
